import React, { createRef, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "src/core/components/modal/modal.component";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";
import FormBuilderComponent, {
  FormConfig,
} from "src/shared/form-builder/form-builder.component";
import { getAssetModels } from "src/store/slices/asset-model.slice";
import { getAllAssetTypes, getAssetTypes } from "src/store/slices/asset-type";
import {
  editAsset,
  getAssetDeploymentType,
  getGatewayByBlockCode,
  getLightType,
} from "src/store/slices/asset.slice";
import { editDevice } from "src/store/slices/dms-device.slice";
// import { getAllFloorsByBlockCode } from "src/store/slices/floor.slice";
import {
  getBlocksBySiteCode,
  // getLocationBlocks,
} from "src/store/slices/location-block.slice";
import { getLocationsByBlockAndFloorCode } from "src/store/slices/location.slice";
import { getSLS } from "src/store/slices/sls.slice";
import { displayToast } from "src/shared/helpers/toaster.helper";
import * as yup from "yup";

interface AssetEditTabProps {
  data: any;
  headerTitle: string;
  setIsEdit: any;
  isDetails?: any;
  setIsDetails?: any;
  setIsModalOpen: any;
  onRefetchData: any;
  isDMSDeviceEdit?: boolean;
  isLoadingData: boolean;
}

const AssetEditTabComponent: React.FC<AssetEditTabProps> = ({
  data,
  headerTitle,
  setIsEdit,
  isDetails,
  setIsDetails,
  setIsModalOpen,
  onRefetchData,
  isDMSDeviceEdit = false,
  isLoadingData = false,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("SmartHubAttribute");
  const [updateSmartHubForm, setUpdateSmartHubForm] = useState(0);
  const [updateInformationForm, setUpdateInformationForm] = useState(0);
  const [updateSensorForm, setUpdateSensorForm] = useState(0);
  const [updateSmartLightingForm, setUpdateSmartLightingForm] = useState(0);

  const [levelOptions, setLevelOptions] = useState<any>([]);
  const [parentAssetsOptions, setParentAssetsOptions] = useState<any>([]);
  const [lightTypeOptions, setLightTypeOptions] = useState<any>([]);
  const [assetDeploymentTypeOptions, setAssetDeploymentTypeOptions] =
    useState<any>([]);
  const [luminaryModelOptions, setLuminaryModelOptions] = useState<any>([]);
  const [locationOptions, setLocationOptions] = useState<any>([]);

  const [assetTypeOptions, setAssetTypeOptions] = useState<any>([]);
  const [floorToLocationOptions, setFloorToLocationOptions] = useState<any>([]);
  const [slsSupplierOptions, setSlsSupplierOptions] = useState<any>([]);

  const [isSettingFormValues, setIsSettingFormValues] = useState(false);
  const [isCriticalDataLoaded, setIsCriticalDataLoaded] = useState(false);

  const [tcCode, setTcCode] = useState(null);
  const [siteCode, setSiteCode] = useState(null);

  const floorResponse = useSelector((state: any) => {
    return state.floor.floorByBlockCode;
  });

  const allAssetTypeResponse = useSelector((state: any) => {
    return state.assetType.allAssetTypes;
  });

  const isLoadingAllAssetType = useSelector((state: any) => {
    return state.assetType.isLoadingAllAssetType;
  });

  const gatewayByBlockCodeResponse = useSelector((state: any) => {
    return state.asset.gatewayByBlockCode;
  });

  // const isLoadingGatewayByBlockCode = useSelector((state: any) => {
  //   return state.asset.isLoadingGatewayByBlockCode;
  // });

  const assetDeploymentTypeResponse = useSelector((state: any) => {
    return state.asset.assetDeploymentType;
  });

  const lightTypeResponse = useSelector((state: any) => {
    return state.asset.lightType;
  });

  const assetModelsResponse = useSelector((state: any) => {
    return state.assetModel.assetModels;
  });

  const locationData = useSelector((state: any) => {
    return state.locationBlock.blocksBySiteCode;
  });

  const isLoadingLocationData = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlocksBySiteCode;
  });

  const floorLocationData = useSelector((state: any) => {
    return state.floorLocation.floorLocations;
  });

  const isLoadingFloorLocations = useSelector((state: any) => {
    return state.floorLocation.isLoadingFloorLocations;
  });

  const slsSupplierResponse = useSelector((state: any) => {
    return state.sls.sls;
  });

  const [selectedBlockCode, setSelectedBlockCode] = useState("");

  const onChangeLocation = (selectedLocation: any) => {
    setSelectedBlockCode(selectedLocation);
  };

  useEffect(() => {
    if (!selectedBlockCode) return;
    dispatch(
      getGatewayByBlockCode({
        blockCode: selectedBlockCode,
      }),
    );

    // dispatch(getAllFloorsByBlockCode({ blockCode: selectedBlockCode }));
  }, [selectedBlockCode]);

  useEffect(() => {
    const gateways = gatewayByBlockCodeResponse?.map((gateway: any) => ({
      label: gateway?.sensorDisplayName,
      value: gateway?.assetCode,
    }));
    // debugger;
    setParentAssetsOptions(gateways);
  }, [gatewayByBlockCodeResponse]);

  useEffect(() => {
    const lightType = lightTypeResponse?.map((lightType: any) => ({
      label: lightType?.name,
      value: lightType?.id,
    }));
    setLightTypeOptions(lightType);
    // debugger;
  }, [lightTypeResponse]);

  useEffect(() => {
    const floors = floorResponse?.data?.map((floor: any) => ({
      label: floor?.displayLevel,
      value: floor?.displayLevel,
    }));

    setLevelOptions(floors);
  }, [floorResponse]);

  useEffect(() => {
    if (!assetDeploymentTypeResponse) return;
    const assetDeploymentTypes = assetDeploymentTypeResponse?.map?.(
      (deploymentType: any) => ({
        label: deploymentType?.value,
        value: deploymentType?.id,
      }),
    );

    setAssetDeploymentTypeOptions(assetDeploymentTypes);
  }, [assetDeploymentTypeResponse]);

  useEffect(() => {
    const assetModels = assetModelsResponse?.data?.map((asset: any) => ({
      label: asset?.assetModelCode,
      value: asset?.assetModelCode,
    }));

    setLuminaryModelOptions(assetModels);
  }, [assetModelsResponse]);

  useEffect(() => {
    const assetTypes = allAssetTypeResponse?.data?.map((assetType: any) => ({
      label: assetType?.name,
      value: assetType?.id,
    }));

    setAssetTypeOptions(assetTypes);
  }, [allAssetTypeResponse]);

  useEffect(() => {
    const blocks = locationData?.data?.map((block: any) => ({
      label: block?.blockCode,
      value: block?.blockCode,
    }));

    setLocationOptions(blocks);
  }, [locationData]);

  useEffect(() => {
    const floorLocations = floorLocationData?.data?.map((location: any) => ({
      label: location?.name,
      value: location?.id,
    }));

    setFloorToLocationOptions(floorLocations);
  }, [floorLocationData]);

  useEffect(() => {
    const sls = slsSupplierResponse?.data?.map((sls: any) => ({
      label: sls?.name,
      value: sls?.id,
    }));

    setSlsSupplierOptions(sls);
  }, [slsSupplierResponse]);

  const onSubmit = () => {
    const formInformationHub: any = formRefInformation.current;
    const formSmartHub: any = formRefSmartHub.current;
    const formSensor: any = formRefSensor.current;
    const formSmartLighting: any = formRefSmartLighting.current;

    let payload = {
      ...formSmartHub?.values,
      ...formSensor?.values,
      ...formSmartLighting?.values,
      ...formInformationHub?.values,
    };

    if (!payload?.latitude) {
      delete payload.latitude;
    }
    if (!payload?.longitude) {
      delete payload.longitude;
    }

    if (isDMSDeviceEdit) {
      payload = {
        ...payload,
        deviceCode: payload.assetCode,
        deviceModel: payload.assetModelCode,
        deviceTypeId: payload.assetTypeId,
        deviceDisplayName: payload.sensorDisplayName,
        registrationTimeStamp: payload.registrationDate,
        driverMode: payload.driverModelCode,
        assetCode: undefined,
        assetModelCode: undefined,
        assetTypeId: undefined,
        sensorDisplayName: undefined,
        registrationDate: undefined,
        driverModelCode: payload.driverModelCode,
        baseline: payload?.baseline || 0,
        latitude: payload?.latitude || null,
        longitude: payload?.longitude || null,
        displayLocationId: payload?.displayLocationId || null,
        tcCode: tcCode,
        siteCode: siteCode,
        installationDateOfSensorDeployement:
          payload?.installationDateOfSensorDeployement || null,
      };

      if ("initialBurnTimeValue" in payload) {
        delete payload.initialBurnTimeValue;
      }

      dispatch(editDevice({ payload, deviceCode: data?.deviceCode })).then(
        () => {
          handleCloseModal();
          onRefetchData();
          setTcCode(null);
          setSiteCode(null);
        },
      );
    } else {
      if (payload?.remarks !== "" && payload?.remarks?.length > 100) {
        if (activeTab !== "SmartLightingAttribute") {
          displayToast("Remarks cannot exceed 100 characters", "red");
        }
        return;
      }

      const updatedPayload = {
        assetModelCode: payload?.assetModelCode || null,
        assetTypeId: payload?.assetTypeId || null,
        availability: payload?.availability || null,
        bandwidth: payload?.bandwidth || null,
        blockCode: payload?.blockCode || null,
        compassBearing: payload?.compassBearing || null,
        connectivityContractExpiry: payload?.connectivityContractExpiry || null,
        dataCollectionMode: payload?.dataCollectionMode || null,
        dataTransmissionMode: payload?.dataTransmissionMode || null,
        dataUsagePerMonth: payload?.dataUsagePerMonth || null,
        deploymentTypeId: payload?.deploymentTypeId || null,
        displayLocationId: payload?.displayLocationId || null,
        driverModelCode: payload?.driverModelCode || null,
        baseline: payload?.baseline || 0,
        floorCode: payload?.floorCode || null,
        isMotionSensor: payload?.isMotionSensor || false,
        isPhotoSensor: payload?.isPhotoSensor || false,
        isRainSensor: payload?.isRainSensor || false,
        isTemparatureSensor: payload?.isTemparatureSensor || false,
        isExcluded: payload?.isExcluded || false,
        remarks: payload?.remarks || "",
        latitude: payload?.latitude || null,
        lightPower: payload?.lightPower || null,
        lightTypeId: payload?.lightTypeId || null,
        longitude: payload?.longitude || null,
        networkConnectivity: payload?.networkConnectivity || null,
        networkConnectivityProvider:
          payload?.networkConnectivityProvider || null,
        parentAssetCode: payload?.parentAssetCode || null,
        powerConsumption: payload?.powerConsumption || null,
        powerSource: payload?.powerSource || null,
        registrationDate: payload?.registrationDate || null,
        resiliency: payload?.resiliency || null,
        security: payload?.security || null,
        sensorCoverage: payload?.sensorCoverage || null,
        initialBurnTimeValue: Number.parseInt(payload?.initialBurnTimeValue) || 0,
        installationDateOfSensorDeployement:
          payload?.installationDateOfSensorDeployement || null,
        sensorDisplayName: payload?.sensorDisplayName || null,
        sensorMaintenanceCompany: payload?.sensorMaintenanceCompany || null,
        serialNumber: payload?.serialNumber || null,
        supplierId: payload?.supplierId || null,
        unit: payload?.unit || null,
        xcoord: payload?.xcoord || null,
        ycoord: payload?.ycoord || null,
        zcoord: payload?.zcoord || null,
      };

      dispatch(
        editAsset({
          assetCode: payload?.assetCode || null,
          payload: updatedPayload,
        }),
      ).then(() => {
        handleCloseModal();
        onRefetchData();
      });
    }
  };

  const modalActionConfig: any = [
    {
      // label: activeTab === "edit block" ? "Save" : "Save",
      label: "Save",
      event: onSubmit,
      variant: "primary",
    },
  ];

  const handleCloseModal = () => {
    setActiveTab("InformationAttribute");
    setUpdateSmartHubForm(0);
    setIsEdit(false);
    if (!isDMSDeviceEdit) setIsDetails(false);
    setIsModalOpen(false);
    setSelectedBlockCode("");

    setInitialValuesInformation({
      assetCode: "",
      blockCode: "",
      floorCode: "",
      displayLocationId: 0,
      assetTypeId: 0,
      parentAssetCode: "", // masterDeviceId
      supplierId: 0,
      lightPower: 0,
    });

    setInitialValuesSmartHub({
      assetModelCode: "",
      sensorDisplayName: "",
      xcoord: 0.0,
      ycoord: 0.0,
      zcoord: 0.0,
      sensorMaintenanceCompany: "",
    });

    setInitialValuesSensor({
      serialNumber: "",
      latitude: "",
      longitude: "",
      deploymentTypeId: 0,
      unit: "",
      sensorCoverage: "",
      initialBurnTimeValue: "",
      installationDateOfSensorDeployement: null,
      powerConsumption: "",
      powerSource: "",
      networkConnectivity: "",
      networkConnectivityProvider: "",
      connectivityContractExpiry: null,
      dataCollectionMode: "",
      bandwidth: "",
      dataTransmissionMode: "",
      dataUsagePerMonth: "",
      availability: "",
      compassBearing: "",
      resiliency: "",
      security: "",
      registrationDate: "",
      lightPower: 0,
    });

    setInitialValuesSmartLighting({
      lightTypeId: 0,
      driverModelCode: "",
      baseline: 0,
      isMotionSensor: false,
      isPhotoSensor: false,
      isRainSensor: false,
      isTemparatureSensor: false,
      isExcluded: false,
      remarks: "",
    });
  };

  const handleTabSelect = (eventKey: any) => {
    setActiveTab(eventKey);
  };

  useEffect(() => {
    dispatch(getLightType());
    dispatch(getAssetDeploymentType());
    dispatch(getAssetModels({ PageNumber: 0, pageSize: 0 }));
    // dispatch(getLocationBlocks({ PageNumber: 0, pageSize: 0 }));
    dispatch(getAssetTypes({ PageNumber: 0, pageSize: 0 }));
    dispatch(getAllAssetTypes({ PageNumber: 0, pageSize: 0 }));
    dispatch(getSLS({ PageNumber: 0, pageSize: 0 }));
    dispatch(getLocationsByBlockAndFloorCode({ PageNumber: 0, PageSize: 0 }));
  }, []);

  useEffect(() => {
    if (!data?.siteCode) return;
    dispatch(getBlocksBySiteCode({ siteCode: data?.siteCode }));
  }, [data]);

  // Information Attributes

  const formRefInformation = createRef();
  const [initialValuesInformation, setInitialValuesInformation] = useState<any>(
    {
      assetCode: "",
      blockCode: "",
      floorCode: "",
      displayLocationId: 0,
      assetTypeId: 0,
      parentAssetCode: "", // masterDeviceId
      supplierId: 0,
      lightPower: 0,
    },
  );
  const formConfigInformation: FormConfig = {
    controls: [
      {
        name: "assetCode",
        label: "Asset ID",
        placeholder: "SJ-560440-01010000",
        type: "text",
        required: !isDetails,
        readOnly: true,
        disabled: true,
      },
      {
        name: "assetTypeId",
        label: "Asset Type",
        placeholder: "Select Asset Type",
        type: "searchable-select",
        options: assetTypeOptions,
        required: !isDetails,
        disabled: true,
      },
      {
        name: "blockCode",
        label: "Display Block",
        placeholder: "Select Postal Code",
        type: "searchable-select",
        options: locationOptions,
        onChange: onChangeLocation,
        required: false,
        disabled: isDetails,
      }, // Conditionally add the parentAssetCode field based on isDMSDeviceEdit
      ...(isDMSDeviceEdit
        ? []
        : [
          {
            name: "parentAssetCode",
            label: "Master Device ID",
            placeholder: "Select Master Device Id",
            type: "searchable-select",
            options: parentAssetsOptions,
            required: false,
            disabled: !selectedBlockCode.length || isDetails,
          },
          {
            name: "displayLocationId",
            label: "Display Location",
            placeholder: "Enter Location",
            type: "searchable-select",
            options: floorToLocationOptions,
            required: false,
            disabled: isDetails,
          },
        ]),
      {
        name: "floorCode",
        label: "Display Level",
        placeholder: "Enter Floor Level",
        type: "searchable-select",
        options: levelOptions,
        required: false,
        disabled: isDetails,
      },
      {
        name: "supplierId",
        label: "Supplier",
        placeholder: "Select Supplier",
        type: "searchable-select",
        options: slsSupplierOptions,
        required: false,
        disabled: isDetails,
      },
      {
        name: "lightPower",
        label: "Light Power (Watts)",
        placeholder: "Light Power",
        type: "number",
        required: false,
        disabled: isDetails,
      },
    ],
  };

  const validationSchemaInformation = yup.object().shape({});

  useEffect(() => {
    if (!data || !Object.keys(data).length) return;

    setIsSettingFormValues(true);

    // Set basic values that don't depend on async options
    setInitialValuesInformation((prev: any) => ({
      ...prev,
      assetCode: isDMSDeviceEdit
        ? data?.deviceCode || ""
        : data?.assetCode || "",
      blockCode: data?.blockCode || "",
      floorCode: data?.floorCode || "",
      displayLocationId: data?.displayLocationId || 0,
      assetTypeId: isDMSDeviceEdit
        ? data?.deviceTypeId || 0
        : data?.assetTypeId || 0,
      parentAssetCode: data?.parentAssetCode || "",
      supplierId: data?.supplierId || 0,
      lightPower: data?.lightPower,
    }));

    setTcCode(data?.tcCode);
    setSiteCode(data?.siteCode);

    // Set selectedBlockCode from data
    if (data?.blockCode && !selectedBlockCode) {
      setSelectedBlockCode(data?.blockCode);
    }

    setIsSettingFormValues(false);
  }, [data, isDMSDeviceEdit]);

  useEffect(() => {
    if (!data || !Object.keys(data)?.length || isSettingFormValues) return;

    // Only update when all required options are available
    const hasRequiredOptions =
      assetTypeOptions?.length > 0 &&
      locationOptions?.length > 0 &&
      slsSupplierOptions?.length > 0;

    if (hasRequiredOptions) {
      setInitialValuesInformation((prev: any) => ({
        ...prev,
        // Only update fields that depend on options
        assetTypeId: isDMSDeviceEdit
          ? data?.deviceTypeId || 0
          : data?.assetTypeId || 0,
        supplierId: data?.supplierId || 0,
      }));

      setUpdateInformationForm((prev) => prev + 1);
    }
  }, [
    data,
    assetTypeOptions,
    locationOptions,
    slsSupplierOptions,
    isDMSDeviceEdit,
    isSettingFormValues,
  ]);

  useEffect(() => {
    if (!data || !selectedBlockCode || isSettingFormValues) return;

    // Check if we have the gateway data for the selected block
    const hasParentAssets = parentAssetsOptions?.length > 0;

    if (hasParentAssets) {
      setInitialValuesInformation((prev: any) => ({
        ...prev,
        parentAssetCode: data?.parentAssetCode || "",
        blockCode: selectedBlockCode,
      }));

      setUpdateInformationForm((prev) => prev + 1);
    }
  }, [data, selectedBlockCode, parentAssetsOptions, isSettingFormValues]);

  useEffect(() => {
    if (!data || !Object.keys(data)?.length) return;

    // Always set blockCode from data, but don't trigger re-fetches unnecessarily
    if (data?.blockCode && data?.blockCode !== selectedBlockCode) {
      setSelectedBlockCode(data?.blockCode);
    }
  }, [data]);

  useEffect(() => {
    // Check if all critical data is loaded
    const criticalDataLoaded =
      assetTypeOptions?.length > 0 &&
      locationOptions?.length > 0 &&
      (!selectedBlockCode || parentAssetsOptions?.length > 0);

    setIsCriticalDataLoaded(criticalDataLoaded);
  }, [
    assetTypeOptions,
    locationOptions,
    parentAssetsOptions,
    selectedBlockCode,
  ]);

  // Smart Hub Attributes
  const formRefSmartHub = createRef();
  const [initialValuesSmartHub, setInitialValuesSmartHub] = useState<any>({
    assetModelCode: "",
    sensorDisplayName: "",
    xcoord: 0.0,
    ycoord: 0.0,
    zcoord: 0.0,
    sensorMaintenanceCompany: "",
  });
  const formConfigSmartHub: FormConfig = {
    controls: [
      {
        name: "assetModelCode",
        label: "Luminaire Model",
        placeholder: "Select Luminaire Model",
        type: "searchable-select",
        options: luminaryModelOptions,
        disabled: isDetails,
        // options and other properties can be added here
      },
      {
        name: "sensorDisplayName",
        label: "Sensor Display Name",
        placeholder: "Enter Sensor Display Name",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "sensorMaintenanceCompany",
        label: "Sensor Maintenance Company",
        placeholder: "Enter Maintenance Company",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "xcoord",
        label: "X Coordinate",
        placeholder: "Enter X Coordinate",
        type: "number",
        required: false,
        disabled: isDetails,
      },
      {
        name: "ycoord",
        label: "Y Coordinate",
        placeholder: "Enter Y Coordinate",
        type: "number",
        required: false,
        disabled: isDetails,
      },
      {
        name: "zcoord",
        label: "Z Coordinate",
        placeholder: "Enter Z Coordinate",
        type: "number",
        required: false,
        disabled: isDetails,
      },
    ],
  };
  const validationSchemaSmartHub = yup.object().shape({});
  useEffect(() => {
    if (!Object.keys(data).length) return;

    setInitialValuesSmartHub({
      assetModelCode: isDMSDeviceEdit
        ? data?.deviceModel || ""
        : data?.assetModelCode || "",
      sensorDisplayName: isDMSDeviceEdit
        ? data?.deviceDisplayName || ""
        : data?.sensorDisplayName || "",
      xcoord: data?.xcoord || 0.0,
      ycoord: data?.ycoord || 0.0,
      zcoord: data?.zcoord || 0.0,
      sensorMaintenanceCompany: data?.sensorMaintenanceCompany || "",
    });

    setUpdateSmartHubForm(updateSmartHubForm + 1);
  }, [data, luminaryModelOptions]);

  // Sensor Attributes

  const formRefSensor = createRef();
  const [initialValuesSensor, setInitialValuesSensor] = useState<any>({
    serialNumber: "",
    latitude: "",
    longitude: "",
    deploymentTypeId: 0,
    unit: "",
    sensorCoverage: "",
    initialBurnTimeValue: "",
    installationDateOfSensorDeployement: null,
    powerConsumption: "",
    powerSource: "",
    networkConnectivity: "",
    networkConnectivityProvider: "",
    connectivityContractExpiry: null,
    dataCollectionMode: "",
    bandwidth: "",
    dataTransmissionMode: "",
    dataUsagePerMonth: "",
    availability: "",
    compassBearing: "",
    resiliency: "",
    security: "",
    registrationDate: "",
    lightPower: 0,
  });
  const formConfigSensor: FormConfig = {
    controls: [
      {
        name: "serialNumber",
        label: "Serial Number",
        placeholder: "Enter Serial Number",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "latitude",
        label: "Latitude",
        placeholder: "Enter Latitude",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "longitude",
        label: "Longitude",
        placeholder: "Enter Longitude",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "deploymentTypeId",
        label: "Deployment Type",
        placeholder: "Enter Deployment Type",
        type: "searchable-select",
        options: assetDeploymentTypeOptions,
        required: false,
        disabled: isDetails,
      },
      {
        name: "unit",
        label: "Unit",
        placeholder: "Enter Unit",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "installationDateOfSensorDeployement",
        label: "Installation Date",
        placeholder: "Enter Installation Date",
        type: "datetime",
        required: false,
        disabled: isDetails,
      },
      ...(isDMSDeviceEdit
        ? []
        : [
          {
            name: "initialBurnTimeValue",
            label: "Initial Burn Time Value",
            placeholder: "Enter Initial Burn Time Value",
            type: "number",
            required: false,
            disabled: isDetails,
          },
        ]),

      {
        name: "sensorCoverage",
        label: "Sensor Coverage",
        placeholder: "Enter Sensor Coverage",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "powerConsumption",
        label: "Power Consumption",
        placeholder: "Enter Power Consumption",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "powerSource",
        label: "Power Source",
        placeholder: "Enter Power Source",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "networkConnectivity",
        label: "Network Connectivity",
        placeholder: "Enter Network Connectivity",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "networkConnectivityProvider",
        label: "Network Connectivity Provider",
        placeholder: "Enter Provider",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "connectivityContractExpiry",
        label: "Connectivity Contract Expiry",
        placeholder: "Select Contract Expiry Date",
        type: "datetime",
        required: false,
        disabled: isDetails,
      },
      {
        name: "dataCollectionMode",
        label: "Data Collection Mode",
        placeholder: "Enter Data Collection Mode",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "bandwidth",
        label: "Bandwidth",
        placeholder: "Enter Bandwidth",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "dataTransmissionMode",
        label: "Data Transmission Mode",
        placeholder: "Enter Data Transmission Mode",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "dataUsagePerMonth",
        label: "Data Usage Per Month",
        placeholder: "Enter Data Usage",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "availability",
        label: "Availability",
        placeholder: "Enter Availability",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "compassBearing",
        label: "Compass Bearing",
        placeholder: "Enter Compass Bearing",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "resiliency",
        label: "Resiliency",
        placeholder: "Enter Resiliency",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "security",
        label: "Security",
        placeholder: "Enter Security",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "registrationDate",
        label: "Registration Date",
        placeholder: "Enter Registration Date",
        type: "datetime",
        required: false,
        disabled: isDetails,
      },
    ],
  };
  const validationSchemaSensor = yup.object().shape({
    serialNumber: yup.string(),
    // .required("Serial Number is required")
    latitude: yup
      .string()
      .test("is-valid-latitude", "Invalid Latitude", (value) => {
        if (!value) return true;
        return /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)/.test(value);
      }),
    // .required("Latitude is required")
    longitude: yup
      .string()
      .test("is-valid-longitude", "Invalid longitude", (value) => {
        if (!value) return true;
        return /^[-+]?((1[0-7]?\d(\.\d+)?|180(\.0+)?))/.test(value);
      }),
    // .required("Longitude is required")
    deploymentTypeId: yup.number(),
    // .required("Deployment Type is required")
    unit: yup.string(),
    // .required("Unit is required")
    sensorCoverage: yup.string(),
    // .required("Sensor Coverage is required")
    powerConsumption: yup.string(),
    // .required("Power Consumption is required")
    powerSource: yup.string(),
    // .required("Power Source is required")
    networkConnectivity: yup.string(),
    // .required("Network Connectivity is required")
    networkConnectivityProvider: yup.string(),
    // .required("Network Connectivity Provider is required")
    connectivityContractExpiry: yup.date().nullable(),
    dataCollectionMode: yup.string().optional(),
    bandwidth: yup.string().optional(),
    dataTransmissionMode: yup.string().optional(),
    dataUsagePerMonth: yup.string().optional(),
    availability: yup.string().optional(),
    compassBearing: yup.string().optional(),
    resiliency: yup.string().optional(),
    security: yup.string().optional(),
    registrationDate: yup.date().nullable(),
  });

  useEffect(() => {
    if (!Object.keys(data).length) return;
    setInitialValuesSensor({
      serialNumber: data?.serialNumber || "",
      latitude: data?.latitude || "",
      longitude: data?.longitude || "",
      deploymentTypeId: data?.deploymentTypeId || 0,
      unit: data?.unit || "",
      sensorCoverage: data?.sensorCoverage || "",
      initialBurnTimeValue: data?.initialBurnTimeValue || "",
      installationDateOfSensorDeployement:
        data?.installationDateOfSensorDeployement || null,
      powerConsumption: data?.powerConsumption || "",
      powerSource: data?.powerSource || "",
      networkConnectivity: data?.networkConnectivity || "",
      networkConnectivityProvider: data?.networkConnectivityProvider || "",
      connectivityContractExpiry:
        data?.connectivityContractExpiry?.slice(0, 16) || null,
      dataCollectionMode: data?.dataCollectionMode || "",
      bandwidth: data?.bandwidth || "",
      dataTransmissionMode: data?.dataTransmissionMode || "",
      dataUsagePerMonth: data?.dataUsagePerMonth || "",
      availability: data?.availability || "",
      compassBearing: data?.compassBearing || "",
      resiliency: data?.resiliency || "",
      security: data?.security || "",
      registrationDate: isDMSDeviceEdit
        ? data?.registrationTimeStamp?.slice(0, 16) || null
        : data?.registrationDate?.slice(0, 16) || null,
      // lightPower: data?.lightPower || 0,
    });

    setUpdateSensorForm(updateSensorForm + 1);
  }, [data, assetDeploymentTypeOptions]);

  // Smart Lighting Attributes

  const formRefSmartLighting = createRef();
  const [initialValuesSmartLighting, setInitialValuesSmartLighting] =
    useState<any>({
      lightTypeId: 0,
      driverModelCode: "",
      baseline: 0,
      isMotionSensor: false,
      isPhotoSensor: false,
      isRainSensor: false,
      isTemparatureSensor: false,
      isExcluded: false,
      remarks: "",
    });

  const formConfigSmartLighting: FormConfig = {
    controls: [
      {
        name: "lightTypeId",
        label: "Light Type",
        placeholder: "Select Light Type",
        type: "searchable-select",
        options: lightTypeOptions,
        required: false,
        disabled: isDetails,
      },
      {
        name: "driverModelCode",
        label: "Driver Model",
        placeholder: "Enter Driver Model",
        type: "text",
        required: false,
        disabled: isDetails,
      },
      {
        name: "baseline",
        label: "Baseline",
        placeholder: "Enter Baseline",
        type: "number",
        required: false,
        disabled: isDetails,
      },
      // Conditionally add the sensor fields based on isDMSDeviceEdit
      ...(isDMSDeviceEdit
        ? []
        : [
          {
            name: "isMotionSensor",
            label: "Motion Sensor",
            type: "switch",
            required: false,
            disabled: isDetails,
          },
          {
            name: "isPhotoSensor",
            label: "Photo Sensor",
            type: "switch",
            required: false,
            disabled: isDetails,
          },
          {
            name: "isRainSensor",
            label: "Rain Sensor",
            type: "switch",
            required: false,
            disabled: isDetails,
          },
          {
            name: "isTemparatureSensor",
            label: "Temperature Sensor",
            type: "switch",
            required: false,
            disabled: isDetails,
          },
          {
            name: "isExcluded",
            label: "Filter Motion Data",
            type: "switch",
            required: false,
            disabled: isDetails,
          },
          {
            name: "remarks",
            label: "Remarks",
            placeholder: "Enter Remarks",
            type: "textarea",
            required: false,
            readOnly: isDetails,
            disabled: isDetails,
          },
        ]),
    ],
  };

  const validationSchemaSmartLighting = yup.object().shape({
    lightTypeId: yup.number(),
    // .required("Light Type is required")
    driverModelCode: yup.string(),
    // .required("Driver Model is required")
    isMotionSensor: yup.boolean().optional(),
    isPhotoSensor: yup.boolean().optional(),
    isRainSensor: yup.boolean().optional(),
    isTemparatureSensor: yup.boolean().optional(),
    isExcluded: yup.boolean().optional(),
    remarks: yup
      .string()
      .optional()
      .max(100, "Remarks cannot exceed 100 characters"),
  });

  useEffect(() => {
    if (!Object.keys(data).length) return;

    setInitialValuesSmartLighting({
      lightTypeId: data?.lightTypeId || 0,
      driverModelCode: data?.driverModelCode || "",
      baseline: data?.baseline || 0,
      isMotionSensor: data?.isMotionSensor || false,
      isPhotoSensor: data?.isPhotoSensor || false,
      isRainSensor: data?.isRainSensor || false,
      isTemparatureSensor: data?.isTemparatureSensor || false,
      isExcluded: data?.isExcluded || false,
      remarks: data?.remarks || "",
    });

    setUpdateSmartLightingForm(updateSmartLightingForm + 1);
  }, [data, lightTypeOptions]);

  return (
    <ModalComponent
      // key={`edit-modal-${data?.assetCode || data?.deviceCode}`}
      isConformationModal={!isDetails}
      isViewMode={!isDetails}
      showModal={true}
      handleClose={handleCloseModal}
      size={"lg"}
      headerTitle={headerTitle}
      actionConfig={isDetails ? undefined : modalActionConfig}
    >
      <SkeletonComponent
        wrapperHeight="650px"
        skeletonHeight="50px"
        isLoading={
          isLoadingAllAssetType ||
          isLoadingLocationData ||
          // isLoadingGatewayByBlockCode ||
          isLoadingFloorLocations ||
          isLoadingData ||
          isSettingFormValues ||
          !isCriticalDataLoaded
        }
        count={10}
      >
        <Tabs
          defaultActiveKey="InformationAttribute"
          id="uncontrolled-tab-example"
          className="mb-3"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="InformationAttribute" title="Info">
            <FormBuilderComponent
              renderCount={updateInformationForm}
              formRef={formRefInformation}
              initialValues={initialValuesInformation}
              validation={validationSchemaInformation}
              formConfig={formConfigInformation}
            />
          </Tab>
          <Tab eventKey="SmartHubAttribute" title="Smart Hub Attribute">
            <FormBuilderComponent
              renderCount={updateSmartHubForm}
              formRef={formRefSmartHub}
              initialValues={initialValuesSmartHub}
              validation={validationSchemaSmartHub}
              formConfig={formConfigSmartHub}
            />
          </Tab>
          <Tab eventKey="SensorAttribute" title="Sensor Attribute">
            <FormBuilderComponent
              formRef={formRefSensor}
              initialValues={initialValuesSensor}
              validation={validationSchemaSensor}
              formConfig={formConfigSensor}
            />
          </Tab>
          <Tab
            eventKey="SmartLightingAttribute"
            title="Smart Lighting Attribute"
          >
            <FormBuilderComponent
              key={`smart-lighting-${updateSmartLightingForm}`}
              formRef={formRefSmartLighting}
              initialValues={initialValuesSmartLighting}
              validation={validationSchemaSmartLighting}
              formConfig={formConfigSmartLighting}
            />
          </Tab>
        </Tabs>
      </SkeletonComponent>
    </ModalComponent>
  );
};

export default AssetEditTabComponent;
